import { forwardRef, useImperativeHandle } from "react"
import { createPortal } from "react-dom"
import useContextMenu from "./useContextMenu"
import { IContextMenu, IContextMenuRef } from "./model"
import { ContextMenuContainer, ContextMenuMain } from "./styles"

const ContextMenu = forwardRef<IContextMenuRef, IContextMenu>(({
  id,
  children,
  menuHeight,
  menuWidth,
}, ref) => {
  const {
    clicked,
    points,
    menuRef,
    show,
    hide,
    togglePreventClose
  } = useContextMenu({ id, menuHeight, menuWidth })

  useImperativeHandle(ref, () => ({
    show,
    hide,
    togglePreventClose
  }))

  if (!clicked) return null

  const renderComponent = (
    <ContextMenuMain ref={menuRef} top={points.y} left={points.x}>
      <ContextMenuContainer>
        {children}
      </ContextMenuContainer>
    </ContextMenuMain>
  )
  return createPortal(renderComponent, document.body)
})

export default ContextMenu
